import React, { CSSProperties, ReactNode } from 'react';

interface GridProps {
  children: ReactNode;
  cols?: number;
  xGap?: number;
  yGap?: number;
  style?: CSSProperties;
  className?: string;
}

export const UiGrid: React.FC<GridProps> = ({ children, cols = 2, xGap = 0, yGap = 0, style, className }) => {
  const gridStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: `repeat(${cols}, 1fr)`,
    gap: `${yGap}px ${xGap}px`,
    ...style,
  };

  return (
    <div
      style={gridStyle}
      className={className}
    >
      {children}
    </div>
  );
};

interface GiProps {
  children: ReactNode;
  span?: number;
  offset?: number;
  style?: CSSProperties;
  className?: string;
}

export const UiGi: React.FC<GiProps> = ({ children, span = 1, offset = 0, style, className }) => {
  const giStyle: CSSProperties = {
    gridColumn: offset ? `span ${span} / span ${span}` : `span ${span}`,
    ...style,
  };

  return (
    <div
      style={giStyle}
      className={className}
    >
      {children}
    </div>
  );
};
